var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"railway-control-content-delete-block"},[_c('div',{class:[
        'railway-control-content-delete-block-wrapper',
        { 'mouseover': _vm.isOver }
      ],on:{"dragleave":function($event){return _vm.onDragLeave()},"dragover":function($event){return _vm.onDragOver($event)},"drop":function($event){return _vm.onCarDrop($event)}}},[_c('r-icon',{attrs:{"name":"trash","color-type":_vm.isOver ? 'error' : '',"size":48}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }